import Task from "./Task";
import { useState } from "react";
export default function TaskContainer() {
  const [todos, setTodos] = useState([]);
  const [task, setTask] = useState("");
  const addTask = (e) => {
    e.preventDefault();
    if (task === "") {
      return alert("Add a task to continue");
    }
    const newToDo = [...todos, { task, completed: false }];
    setTodos(newToDo);
    setTask("");
  };
  const deleteToDo = (index) => {
      const newToDos = [...todos];
      newToDos.splice(index,1);
      setTodos(newToDos);
  }
  const completeToDo = (index) => {
      const newToDos = [...todos];
      newToDos[index].completed === false?(newToDos[index].completed = true):(newToDos[index].completed = false);
      setTodos(newToDos);
  }
  const updateToDo = (index) => {
    const newToDos = [...todos];
    const updatetask = newToDos[index];
    console.log(updatetask);
    let newTask = prompt(`Update ${updatetask.task}?`,updatetask.task);
    console.log(newTask);
    let newToDoTask = {task:newTask,completed:false};
    newToDos.splice(index,1,newToDoTask);
    if (newTask === null || newTask === "") {
        return;
    } else {
        updatetask.task = newTask;
    }
    setTodos(newToDos);
    console.log(todos);
  }
  return (
    <div className="container w-75">
        <label className="title">What's your plan today?</label>
        <div className="input-group pt-3">
          <input
            type="text"
            className="form-control"
            value={task}
            placeholder="Add your task"
            onChange={(e) => setTask(e.target.value)}
          />
          <span className="input-group-btn">
          <button className="btn btn-danger" onClick={addTask}>
            Create Task
          </button></span>
        </div>
        <div className="tasklist mt-4">
          {todos.map((item, index) => (
            <Task key={index} index={index} todo={item} deleteToDo = {deleteToDo} completeToDo={completeToDo} updateToDo={updateToDo}/>
          ))}
        </div>
    </div>
  );
}
